module.exports = __webpack_public_path__ + "img/lock-white.b8c034a5.svg";